import {SvgIcon} from '@shipwell/shipwell-ui';
import {ArrayHelpers} from 'formik';
export const LineItemDeleteButton = ({onClick, index}: {onClick: ArrayHelpers['remove']; index: number}) => {
  return (
    <button onClick={() => onClick(index)}>
      <SvgIcon name="TrashOutlined" />
    </button>
  );
};
